const quota_item = {
    tenant_limit: {
        name: 'ผู้เช่า',
        limited: '{{count, number}} ผู้เช่า',
        limited_other: '{{count, number}} ผู้เช่า',
        unlimited: 'ไม่จำกัดผู้เช่า',
        not_eligible: 'ลบผู้เช่าของคุณ',
    },
    mau_limit: {
        name: 'ผู้ใช้ที่ใช้งานต่อเดือน',
        limited: '{{count, number}} ผู้ใช้ที่ใช้งานต่อเดือน',
        unlimited: 'ไม่จำกัดผู้ใช้ที่ใช้งานต่อเดือน',
        not_eligible: 'ลบผู้ใช้ทั้งหมดของคุณ',
    },
    token_limit: {
        name: 'โทเคน',
        limited: '{{count, number}} โทเคน',
        limited_other: '{{count, number}} โทเคน',
        unlimited: 'ไม่จำกัดโทเคน',
        not_eligible: 'ลบผู้ใช้ทั้งหมดของคุณเพื่อป้องกันการสร้างโทเคนใหม่',
    },
    applications_limit: {
        name: 'แอปพลิเคชัน',
        limited: '{{count, number}} แอปพลิเคชัน',
        limited_other: '{{count, number}} แอปพลิเคชัน',
        unlimited: 'ไม่จำกัดแอปพลิเคชัน',
        not_eligible: 'ลบแอปพลิเคชันของคุณ',
    },
    machine_to_machine_limit: {
        name: 'Machine to machine',
        limited: '{{count, number}} แอป machine to machine',
        limited_other: '{{count, number}} แอป machine to machine',
        unlimited: 'ไม่จำกัดแอป machine to machine',
        not_eligible: 'ลบแอป machine to machine ของคุณ',
    },
    third_party_applications_limit: {
        name: 'แอปของบุคคลที่สาม',
        limited: '{{count, number}} แอปของบุคคลที่สาม',
        limited_other: '{{count, number}} แอปของบุคคลที่สาม',
        unlimited: 'ไม่จำกัดแอปของบุคคลที่สาม',
        not_eligible: 'ลบแอปของบุคคลที่สามของคุณ',
    },
    resources_limit: {
        name: 'API resources',
        limited: '{{count, number}} ทรัพยากร API',
        limited_other: '{{count, number}} ทรัพยากร API',
        unlimited: 'ไม่จำกัดทรัพยากร API',
        not_eligible: 'ลบทรัพยากร API ของคุณ',
    },
    scopes_per_resource_limit: {
        name: 'สิทธิ์การเข้าถึงทรัพยากร',
        limited: '{{count, number}} สิทธิ์ต่อทรัพยากร',
        limited_other: '{{count, number}} สิทธิ์ต่อทรัพยากร',
        unlimited: 'ไม่จำกัดสิทธิ์ต่อทรัพยากร',
        not_eligible: 'ลบสิทธิ์การเข้าถึงทรัพยากรของคุณ',
    },
    custom_domain_enabled: {
        name: 'โดเมนแบบกำหนดเอง',
        limited: 'โดเมนแบบกำหนดเอง',
        unlimited: 'โดเมนแบบกำหนดเอง',
        not_eligible: 'ลบโดเมนแบบกำหนดเองของคุณ',
    },
    omni_sign_in_enabled: {
        name: 'Omni sign-in',
        limited: 'Omni sign-in',
        unlimited: 'Omni sign-in',
        not_eligible: 'ปิดใช้งาน omni sign-in ของคุณ',
    },
    built_in_email_connector_enabled: {
        name: 'ตัวเชื่อมต่ออีเมลในตัว',
        limited: 'ตัวเชื่อมต่ออีเมลในตัว',
        unlimited: 'ตัวเชื่อมต่ออีเมลในตัว',
        not_eligible: 'ลบตัวเชื่อมต่ออีเมลในตัวของคุณ',
    },
    social_connectors_limit: {
        name: 'ตัวเชื่อมต่อโซเชียล',
        limited: '{{count, number}} ตัวเชื่อมต่อโซเชียล',
        limited_other: '{{count, number}} ตัวเชื่อมต่อโซเชียล',
        unlimited: 'ไม่จำกัดตัวเชื่อมต่อโซเชียล',
        not_eligible: 'ลบตัวเชื่อมต่อโซเชียลของคุณ',
    },
    standard_connectors_limit: {
        name: 'ตัวเชื่อมต่อมาตรฐานฟรี',
        limited: '{{count, number}} ตัวเชื่อมต่อมาตรฐานฟรี',
        limited_other: '{{count, number}} ตัวเชื่อมต่อมาตรฐานฟรี',
        unlimited: 'ไม่จำกัดตัวเชื่อมต่อมาตรฐาน',
        not_eligible: 'ลบตัวเชื่อมต่อมาตรฐานของคุณ',
    },
    roles_limit: {
        name: 'บทบาท',
        limited: '{{count, number}} บทบาท',
        limited_other: '{{count, number}} บทบาท',
        unlimited: 'ไม่จำกัดบทบาท',
        not_eligible: 'ลบบทบาทของคุณ',
    },
    machine_to_machine_roles_limit: {
        name: 'บทบาท machine to machine',
        limited: '{{count, number}} บทบาท machine to machine',
        limited_other: '{{count, number}} บทบาท machine to machine',
        unlimited: 'ไม่จำกัดบทบาท machine to machine',
        not_eligible: 'ลบบทบาท machine to machine ของคุณ',
    },
    scopes_per_role_limit: {
        name: 'สิทธิ์ของบทบาท',
        limited: '{{count, number}} สิทธิ์ต่อบทบาท',
        limited_other: '{{count, number}} สิทธิ์ต่อบทบาท',
        unlimited: 'ไม่จำกัดสิทธิ์ต่อบทบาท',
        not_eligible: 'ลบสิทธิ์ของบทบาทของคุณ',
    },
    hooks_limit: {
        name: 'Webhook',
        limited: '{{count, number}} webhook',
        limited_other: '{{count, number}} webhook',
        unlimited: 'ไม่จำกัด webhook',
        not_eligible: 'ลบ webhook ของคุณ',
    },
    organizations_enabled: {
        name: 'องค์กร',
        limited: 'องค์กร',
        unlimited: 'องค์กร',
        not_eligible: 'ลบองค์กรของคุณ',
    },
    audit_logs_retention_days: {
        name: 'ระยะเวลาการเก็บบันทึก audit',
        limited: 'ระยะเวลาการเก็บบันทึก audit: {{count, number}} วัน',
        limited_other: 'ระยะเวลาการเก็บบันทึก audit: {{count, number}} วัน',
        unlimited: 'ไม่จำกัดวัน',
        not_eligible: 'ไม่มีบันทึก audit',
    },
    email_ticket_support: {
        name: 'การซัพพอร์ตทางอีเมล',
        limited: 'การซัพพอร์ตทางอีเมลภายใน {{count, number}} ชั่วโมง',
        limited_other: 'การซัพพอร์ตทางอีเมลภายใน {{count, number}} ชั่วโมง',
        unlimited: 'การซัพพอร์ตทางอีเมล',
        not_eligible: 'ไม่มีการซัพพอร์ตทางอีเมล',
    },
    mfa_enabled: {
        name: 'การยืนยันตัวตนหลายปัจจัย',
        limited: 'การยืนยันตัวตนหลายปัจจัย',
        unlimited: 'การยืนยันตัวตนหลายปัจจัย',
        not_eligible: 'ลบการยืนยันตัวตนหลายปัจจัยของคุณ',
    },
    sso_enabled: {
        name: 'SSO สำหรับองค์กร',
        limited: 'SSO สำหรับองค์กร',
        unlimited: 'SSO สำหรับองค์กร',
        not_eligible: 'ลบ SSO สำหรับองค์กรของคุณ',
    },
    tenant_members_limit: {
        name: 'สมาชิกผู้เช่า',
        limited: '{{count, number}} สมาชิกผู้เช่า',
        limited_other: '{{count, number}} สมาชิกผู้เช่า',
        unlimited: 'ไม่จำกัดสมาชิกผู้เช่า',
        not_eligible: 'ลบสมาชิกผู้เช่าของคุณ',
    },
    custom_jwt_enabled: {
        name: 'JWT แบบกำหนดเอง',
        limited: 'JWT แบบกำหนดเอง',
        unlimited: 'JWT แบบกำหนดเอง',
        not_eligible: 'ลบตัวปรับแต่ง claim ของ JWT ของคุณ',
    },
    impersonation_enabled: {
        name: 'การสวมตัวตน',
        limited: 'การสวมตัวตน',
        unlimited: 'การสวมตัวตน',
        not_eligible: 'ไม่อนุญาตให้สวมตัวตน',
    },
    bring_your_ui_enabled: {
        name: 'นำ UI ของคุณมาใช้',
        limited: 'นำ UI ของคุณมาใช้',
        unlimited: 'นำ UI ของคุณมาใช้',
        not_eligible: 'ลบไฟล์ UI แบบกำหนดเองของคุณ',
    },
    collect_user_profile_enabled: {
        name: 'รวบรวมโปรไฟล์ผู้ใช้',
        limited: 'รวบรวมโปรไฟล์ผู้ใช้',
        unlimited: 'รวบรวมโปรไฟล์ผู้ใช้',
        not_eligible: 'ลบฟิลด์ข้อมูลการรวบรวมโปรไฟล์ผู้ใช้ของคุณ',
    },
    idp_initiated_sso_enabled: {
        name: 'IDP-initiated SSO',
        limited: 'IDP-initiated SSO',
        unlimited: 'IDP-initiated SSO',
        not_eligible: 'ไม่อนุญาตให้ใช้ IDP-initiated SSO',
    },
    saml_applications_limit: {
        name: 'แอป SAML',
        limited: '{{count, number}} แอป SAML',
        limited_other: '{{count, number}} แอป SAML',
        unlimited: 'ไม่จำกัดแอป SAML',
        not_eligible: 'ลบแอป SAML ของคุณ',
    },
    captcha_enabled: {
        name: 'CAPTCHA',
        limited: 'CAPTCHA',
        unlimited: 'CAPTCHA',
        not_eligible: 'ลบ CAPTCHA ของคุณ',
    },
    security_features_enabled: {
        name: 'ความปลอดภัยขั้นสูง',
        limited: 'ความปลอดภัยขั้นสูง',
        unlimited: 'ความปลอดภัยขั้นสูง',
        not_eligible: 'ลบการตั้งค่าความปลอดภัยขั้นสูงของคุณ',
    },
    custom_domains_limit: {
        name: 'โดเมนแบบกำหนดเอง',
        limited: '{{count, number}} โดเมนแบบกำหนดเอง',
        limited_other: '{{count, number}} โดเมนแบบกำหนดเอง',
        unlimited: 'ไม่จำกัดโดเมนแบบกำหนดเอง',
        not_eligible: 'ลบโดเมนแบบกำหนดเองของคุณ',
    },
};
export default Object.freeze(quota_item);
